import { render } from "./FooterSite.vue?vue&type=template&id=5c48a3a9"
import script from "./FooterSite.vue?vue&type=script&lang=js"
export * from "./FooterSite.vue?vue&type=script&lang=js"

import "./FooterSite.vue?vue&type=style&index=0&id=5c48a3a9&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__